import {
  NavigationConfiguration,
  NavigationContext,
  NavigationLink,
  NavigationItem as TNavigationItem
} from '@lib/docs/types';
import { useRouter } from 'next/router';
import { NavigationItem } from './nav-item';
import { determineNavigationItemType } from '@lib/docs/nav';

export function NavigationItems({
  config
}: {
  config: NavigationConfiguration;
}) {
  const { asPath } = useRouter();
  const activePath = asPath.replace(/#.*/, ''); // Remove hash fragment

  return (
    <>
      {config.map((item, index) => {
        const isNavigationContext =
          Array.isArray(item) &&
          typeof item[0] === 'object' &&
          'root' in item[0];

        // detect separator in order to generate unique keys
        const isSeparator = determineNavigationItemType(item) === 'separator';

        if (isNavigationContext) {
          const textConfig = item[0] as NavigationContext[0];

          // For a navigation context, the top-level link should point at the first link in its children. We find the first link here and use its path when rendering the nav context item.
          const subArray = item[1] as TNavigationItem[];
          const firstLinkNode = subArray.find(
            node => determineNavigationItemType(node) === 'link'
          ) as NavigationLink | undefined;

          const initialPath = firstLinkNode
            ? firstLinkNode[1]
            : textConfig.root;

          return (
            <NavigationItem
              key={JSON.stringify(textConfig)}
              item={[textConfig, initialPath]}
              activePath={activePath}
            />
          );
        }

        return (
          <NavigationItem
            key={isSeparator ? `separator-${index}` : JSON.stringify(item)}
            item={item}
            activePath={activePath}
          />
        );
      })}
    </>
  );
}
